import clientAxios from '../../client-axios';
import ActionType from '../action-types';
import { detectError } from '../../utils';
// import axios from "../../axios-fetches";

export const signOut = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SIGNOUT_START
    });

    try {
      localStorage.removeItem('user');
      dispatch({
        type: ActionType.SIGNOUT_SUCCESS
      });
    } catch (error) {
      dispatch({
        type: ActionType.SIGNOUT_ERROR,
        payload: error.message
      });
    }
  };
};

export const signinUser = (phone, password) => {
  // accept user credentials parameter
  return async (dispatch) => {
    dispatch({
      type: ActionType.AUTH_START
    });
    try {
      // send request to login user
      const res = await clientAxios.post('/auth/login', { phone, password });

      if (res.data.message === 'Change Default password') {
        const date = new Date();
        const userCred = {
          id: res.data.user_id,
          expiresIn: date.setDate(date.getDate() + 1),
          stationId: res.data.station_id
        };

        localStorage.setItem('user', JSON.stringify(userCred));
        dispatch({
          type: ActionType.STAFF_CHANGE_PASSWORD,
          payload: res.data.user_id
        });
      } else {
        // Get access token
        const { user_id, token, station_id } = res.data;

        if (user_id) {
          const date = new Date();
          // Get token expiry date time
          const expiresIn = date.setDate(date.getDate() + 1);
          // const expiresIn = new Date(date.getTime() + (5*60000)) // 5 minutes
          // const expiresIn = new Date(date - 60 * 60000); // expire 1 hr before

          // Send request to get current user details
          const user = await clientAxios.get(`/staff/view/${user_id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });

          const userCred = {
            expiresIn: expiresIn,
            accessToken: token,
            id: user_id,
            firstname: user.data.data.firstname,
            lastname: user.data.data.lastname,
            phone: user.data.data.phone,
            status: user.data.data.status,
            designation: user.data.data.designation,
            stationId: station_id,
            staffId: user.data.data.staff_id,
            kinFirstname: user.data.data.NextofKin_firstname,
            kinLastname: user.data.data.NextofKin_lastname,
            kinRelationship: user.data.data.NextofKin_relationship,
            kinPhone: user.data.data.NextofKin_phone
          };

          localStorage.setItem('user', JSON.stringify(userCred));

          const expires = new Date(expiresIn);
          const now = new Date();
          const expMilliSeconds = expires.getTime() - now.getTime();

          setTimeout(() => {
            dispatch(signOut());
          }, expMilliSeconds);

          dispatch({
            type: ActionType.AUTH_SUCCESS,
            payload: userCred
          });
        } else {
          dispatch({
            type: ActionType.AUTH_ERROR,
            payload: res.data.message || 'Something went wrong, Please try again'
          });
        }
      }
    } catch (error) {
      let message = detectError(error);

      if (!message) {
        message = 'Something went wrong, Please try again';
      }

      dispatch({
        type: ActionType.AUTH_ERROR,
        payload: message
      });
    }
  };
};

export const changePasswordSuccess = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.STAFF_CHANGE_PASSWORD_SUCCESS
    });
  };
};

// Auto sign in on reload
export const authCheckState = () => {
  return async (dispatch) => {
    // Get token userId, and exp date from local storage
    // to update to indexed db later
    const authuser = localStorage.getItem('user');

    if (!authuser) {
      dispatch(signOut());
    } else {
      const {
        id,
        expiresIn,
        firstname,
        lastname,
        phone,
        status,
        designationId,
        profileImage,
        stationId,
        staffId,
        kinFirstname,
        kinLastname,
        kinRelationship,
        kinPhone
      } = JSON.parse(authuser);

      const expirationDate = new Date(expiresIn);
      if (expirationDate < new Date()) {
        dispatch(signOut());
      } else {
        dispatch({
          type: ActionType.AUTH_SUCCESS,
          payload: {
            id,
            firstname,
            lastname,
            phone,
            status,
            designationId,
            profileImage,
            stationId,
            staffId,
            kinFirstname,
            kinLastname,
            kinRelationship,
            kinPhone
          }
        });
        const expires = new Date(expiresIn);
        const now = new Date();
        // const expMilliSeconds = +new Date(expiresIn) - +new Date()
        const expMilliSeconds = expires.getTime() - now.getTime();
        setTimeout(() => {
          dispatch(signOut());
        }, expMilliSeconds);
      }
    }
  };
};

export const getCurrentUser = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.CURRENT_USER_START
    });

    try {
      // send request to get current user
      dispatch({
        type: ActionType.CURRENT_USER_SUCCESS,
        payload: {} // response data
      });
    } catch (error) {
      let message = 'Unable to connect';
      if (error?.response) {
        if (Array.isArray(error.response.data?.message)) {
          message = error.response.data.message.join('\n');
        } else {
          message = error?.response.data?.message;
        }
      }
      if (!message) {
        message = 'Something went wrong';
      }
      dispatch({
        type: ActionType.CURRENT_USER_ERROR,
        payload: message
      });
    }
  };
};

export const updateUser = (data) => {
  return async (dispatch) => {
    try {
      const user = localStorage.getItem('user');
      let userData;

      if (user) {
        userData = JSON.parse(user);
      }

      const userCred = {
        id: data.id,
        username: data.username,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        is_superuser: data.is_superuser,
        is_staff: data.is_staff,
        expiresIn: userData?.expiresIn,
        accessToken: userData?.accessToken
      };

      localStorage.setItem('user', JSON.stringify(userCred));

      dispatch({
        type: ActionType.AUTH_SUCCESS,
        payload: userCred
      });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };
};

export const clearError = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.CLEAR_ERROR
    });
  };
};
